import CmsBlocks from 'libs/wordpress/content/CmsBlocks';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import SpecialTwoColumnsLayout from 'components/contentLayouts/SpecialTwoColumnsLayout';
import { mediaQueries } from 'config/theme/breakpoints';

const TwoColumnsLayout = ({ content = {}, ...rest }) => {
    const { columns } = content;

    // We should not render the two column if the data is not correct.
    if (columns.length !== 2) {
        return null;
    }

    return (
        <MaxWidthWrapper includeContentMargins as="section">
            <SpecialTwoColumnsLayout
                // Handle how the content inside each columns should be rendred
                blocks={columns.map((column, index) => (
                    <CmsBlocks
                        isColumn
                        data={column}
                        key={`${column.layout}-${index}`}
                        mediaQuery={mediaQueries.twoColumn}
                        {...rest}
                    />
                ))}
            />
        </MaxWidthWrapper>
    );
};

TwoColumnsLayout.propTypes = {
    content: PropTypes.object,
};

export default TwoColumnsLayout;
